import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBarChart = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2 11C2 10.4477 2.44772 10 3 10H7C7.55228 10 8 10.4477 8 11V19C8 19.5523 7.55228 20 7 20H3C2.44772 20 2 19.5523 2 19V11ZM4 12V18H6V12H4Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V19C15 19.5523 14.5523 20 14 20H10C9.44772 20 9 19.5523 9 19V4ZM11 5V18H13V5H11Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16 8C16 7.44772 16.4477 7 17 7H21C21.5523 7 22 7.44772 22 8V19C22 19.5523 21.5523 20 21 20H17C16.4477 20 16 19.5523 16 19V8ZM18 9V18H20V9H18Z",
			fill: "currentColor"
		})
	]
});
export default SvgBarChart;
